import React from 'react';

const VesselIcon: React.FC<{ size?: number; color?: string; style?: React.CSSProperties }> = ({
  size = 24,
  color = 'currentColor',
  style = {},
}) => (
<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_535_18853)">
      <path d="M4 10.4V4C4 3.73478 4.10536 3.48043 4.29289 3.29289C4.48043 3.10536 4.73478 3 5 3H10V1H14V3H19C19.2652 3 19.5196 3.10536 19.7071 3.29289C19.8946 3.48043 20 3.73478 20 4V10.4L21.086 10.726C21.3321 10.8001 21.5402 10.966 21.6672 11.1895C21.7942 11.4129 21.8303 11.6767 21.768 11.926L20.252 17.994C19.6064 18.0273 18.9604 17.935 18.35 17.722L19.6 12.37L12 10L4.4 12.37L5.65 17.721C5.03966 17.9343 4.3937 18.027 3.748 17.994L2.232 11.926C2.1697 11.6767 2.20578 11.4129 2.33277 11.1895C2.45976 10.966 2.6679 10.8001 2.914 10.726L4 10.4ZM6 9.8L12 8L18 9.8V5H6V9.8ZM4 20C5.47626 20.002 6.90107 19.4578 8 18.472C9.09893 19.4578 10.5237 20.002 12 20C13.4763 20.002 14.9011 19.4578 16 18.472C17.0989 19.4578 18.5237 20.002 20 20H22V22H20C18.5956 22.0023 17.2157 21.6331 16 20.93C14.7843 21.6331 13.4044 22.0023 12 22C10.5956 22.0023 9.21565 21.6331 8 20.93C6.78435 21.6331 5.40436 22.0023 4 22H2V20H4Z" stroke={color} fill="#09121F" />
    </g>
    <defs>
      <clipPath id="clip0_535_18853">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default VesselIcon;
